/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as moment from 'moment';
const UNITS = Object.freeze(['B', 'KB', 'MB', 'GB', 'TB']);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function size(sz, maxDigits) {
    let n = sz;
    let unit = 'B';
    for (unit of UNITS) {
        if (n < 1024)
            break;
        n /= 1024;
    }
    if (maxDigits == null || maxDigits < 0) {
        return `${n}${unit}`;
    }
    else {
        return `${n.toFixed(maxDigits)}${unit}`;
    }
}
/**
 * Returns the duration formatted as `HHh MMm SSs`.
 *
 * Each of these will not be shown if not necessary. If the duration is of 75
 * seconds, it will only show `1m 15s`, not `0h 1m 15s`.
 *
 * @param dur The duration.
 * @returns The formatted duration.
 */
export function duration(dur) {
    let seconds = Math.round(dur.asSeconds());
    const negative = seconds < 0;
    seconds = Math.abs(seconds);
    let res;
    if (seconds < 60) {
        res = `${seconds}s`;
    }
    else {
        const secondPart = seconds % 60;
        const minutePart = ((seconds - secondPart) / 60) % 60;
        if (seconds < 60 * 60) {
            res = `${minutePart}m ${secondPart}s`;
        }
        else {
            const hourPart = ((seconds - secondPart - minutePart * 60) / (60 * 60)) % 60;
            res = `${hourPart}h ${minutePart}m ${secondPart}s`;
        }
    }
    return negative ? `-${res}` : res;
}
/**
 * Same as {@link duration} but then also showing the millisecond part.
 *
 * @param dur The duration.
 * @returns The formatted duration.
 */
export function durationWithMs(dur) {
    const ms = Math.round(dur.asMilliseconds()) % 1000;
    const base = duration(dur.clone().subtract(moment.duration(ms, 'ms')));
    const displayMs = Math.abs(ms);
    if (base === '0s') {
        const negativeSign = ms < 0 ? '-' : '';
        return `${negativeSign}${displayMs}ms`;
    }
    else {
        return `${base} ${displayMs}ms`;
    }
}
/**
 * Produces a humanly readable number or fraction.
 *
 * Either a number with a limited and readable amount of decimal digits or
 * a readable fraction like `N/D`.
 *
 * If the number of digits is less than 4 but periodic, the fractional
 * representation is used.
 *
 * @param value The fraction to humanize.
 * @param maximumDecimals Maximum number of decimals before transforming into a fraction.
 * @returns The most human readable representation of the fraction.
 */
export function fraction(value, maximumDecimals = 4) {
    const firstGuess = value.toString();
    const pointLocation = firstGuess.indexOf('.');
    if (pointLocation < 0) {
        return firstGuess;
    }
    if (firstGuess.includes('(') || firstGuess.length - pointLocation - 1 > maximumDecimals) {
        return value.toFraction();
    }
    return firstGuess;
}
